"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskAuditListItem = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const core_2 = require("@sierralabs/core");
const StyledListItem = (0, styled_components_1.default)(core_1.ListItem) `
  flex-direction: column;
  align-items: flex-start;
  &.collapse {
    .field-change {
      flex-direction: row;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
    }
    ins {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .field-change {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    .field {
      margin-right: 8px;
    }
  }
  del {
    display: inline;
    background: #ffbdad;
    padding: 3px 2px;
    font-size: 11px;
  }
  ins {
    display: inline;
    background: #abf5d3;
    padding: 3px 2px;
    text-decoration: none;
    font-size: 11px;
  }
`;
const TaskAuditListItem = props => {
    const { log } = props;
    const [collapse, setCollapse] = (0, react_1.useState)(true);
    const classes = ['list-item'];
    collapse && classes.push('collapse');
    return (react_1.default.createElement(StyledListItem, { button: true, divider: true, className: classes.join(' '), onClick: () => setCollapse(!collapse) },
        react_1.default.createElement(core_1.Typography, { variant: 'overline' },
            (0, core_2.formatDate)(log.created),
            " (",
            log.createdBy.firstName,
            ' ',
            log.createdBy.lastName,
            ")"),
        Object.keys(log.newValue).map(key => {
            if (key === 'id')
                return null;
            let fieldLabel = translateKey(key);
            fieldLabel = fieldLabel.replace(/([A-Z])/g, ' $1');
            fieldLabel = fieldLabel.charAt(0).toUpperCase() + fieldLabel.slice(1);
            const oldValue = renderValue(key, log.oldValue[key]);
            let newValue = renderValue(key, log.newValue[key]);
            if (collapse && typeof newValue === 'string')
                newValue = newValue.replace(/(<([^>]+)>)/gi, '');
            return (react_1.default.createElement("div", { className: 'field-change', key: key },
                react_1.default.createElement(core_1.Typography, { variant: 'subtitle2', className: 'field' }, fieldLabel),
                !collapse && (react_1.default.createElement("del", { dangerouslySetInnerHTML: { __html: oldValue } })),
                collapse && !newValue ? (react_1.default.createElement("del", { dangerouslySetInnerHTML: { __html: oldValue } })) : (react_1.default.createElement("ins", { dangerouslySetInnerHTML: { __html: newValue } }))));
        })));
};
exports.TaskAuditListItem = TaskAuditListItem;
exports.default = exports.TaskAuditListItem;
function translateKey(key) {
    return key;
}
function renderValue(key, value) {
    if (value === null)
        return '';
    if (Array.isArray(value)) {
        return value.map(value => renderValue(key, value)).join(', ');
    }
    if (value instanceof Date) {
        return (0, core_2.formatDate)(value);
    }
    switch (typeof value) {
        case 'object': {
            const key = [
                'name',
                'title',
                'firstName',
                'lastName',
                'description',
                'stepNo'
            ].find(key => Object.keys(value).includes(key));
            if (key === 'firstName') {
                return `${value['firstName']} ${value['lastName']}`;
            }
            else if (key) {
                return value[key];
            }
            else {
                return JSON.stringify(value);
            }
        }
    }
    return value;
}
//# sourceMappingURL=TaskAuditLogListItem.js.map